<template>
  <div class="loading" v-show="isShow.isLDShow">
    <logo />
    <div class="l-main">
      <img src="./loading_moon.png" alt="moon">
      <span>{{ loadingNum }}%</span>
      <div class="l-mask movingMoon"></div>
    </div>
    <div class="preImgBox">
      <span v-for="(data,index) in preLoadImg" :key="generateId(index)">
        <img v-bind:id="generateId(index)" src="" style="visibility: hidden; width: 1px; height: 1px; position: absolute;">
      </span>
    </div>
  </div>
</template>

<script>
import Logo from '../../components/logo/logo'
import $ from "jquery";

export default {
  name: 'Loading',
  props: {
    isShow: {
      type: Object
    }
  },
  data () {
    return {
      loadingNum: 0,
      preLoadImg: [
        { src: require('./logo.png') },
        { src: require('./loading_moon.png') },
        { src: require('../page-kv/kv_btn.png') },
        { src: require('../page-kv/kv_car.png') },
        { src: require('../page-kv/kv_land.png') },
        { src: require('../page-kv/kv_moon.png') },
        { src: require('../page-kv/kv_para.png') },
        { src: require('../page-kv/kv_people.png') },
        { src: require('../page-kv/kv_bg.png') },
        { src: require('../page-one/pg1_bg.jpg') },
        { src: require('../../components/toast/cm_person1.jpg') },
        { src: require('../../components/toast/cm_person2.jpg') },
        { src: require('../../components/toast/cm_person3.jpg') },
        { src: require('../../components/toast/cm_person4.jpg') },
        { src: require('../../components/toast/cm_person5.jpg') },
        { src: require('../../components/toast/cm_person6.jpg') },
        { src: require('../../components/toast/cm_s1-desc.png') },
        { src: require('../../components/toast/cm_s1-slc1-a.png') },
        { src: require('../../components/toast/cm_s1-slc1-u.png') },
        { src: require('../../components/toast/cm_s2-desc.png') },
        { src: require('../../components/toast/cm_s2-slc1-a.png') },
        { src: require('../../components/toast/cm_s2-slc1-u.png') },
        { src: require('../../components/toast/cm_s3-desc.png') },
        { src: require('../../components/toast/cm_s3-slc1-a.png') },
        { src: require('../../components/toast/cm_s3-slc1-u.png') },
        { src: require('../../components/toast/cm_s4-desc.png') },
        { src: require('../../components/toast/cm_s4-slc1-a.png') },
        { src: require('../../components/toast/cm_s4-slc1-u.png') },
        { src: require('../../components/toast/cm_s5-desc.png') },
        { src: require('../../components/toast/cm_s5-slc1-a.png') },
        { src: require('../../components/toast/cm_s5-slc1-u.png') },
        { src: require('../../components/toast/cm_s6-desc.png') },
        { src: require('../../components/toast/cm_s6-slc1-a.png') },
        { src: require('../../components/toast/cm_s6-slc1-u.png') },
        { src: require('../../components/toast/cm_slc2-a.png') },
        { src: require('../../components/toast/cm_slc2-u.png') },
        { src: require('../../components/toast/cm_title1.png') },
        { src: require('../../components/toast/cm_title2.png') },
        { src: require('../../components/toast/cm_title3.png') },
        { src: require('../../components/toast/cm_title4.png') },
        { src: require('../../components/toast/cm_title5.png') },
        { src: require('../../components/toast/cm_title6.png') },
        { src: require('../../components/toast/cm_titleBg.png') },
        { src: require('../../components/toast/cm_titleBg2.png') },
        { src: require('../../components/toast/cm_toast.png') },
        { src: require('../../components/toast/s1_bg.png') },
        { src: require('../../components/toast/s1_bgDesc.png') },
        { src: require('../../components/toast/s2_bgDesc.png') },
        { src: require('../../components/toast/s3_bgDesc.png') },
        { src: require('../../components/toast/s4_bgDesc.png') },
        { src: require('../../components/toast/s5_bgDesc.png') },
        { src: require('../../components/toast/s6_bgDesc.png') },

        { src: require('../page-two/ltr_bg.png') },
        { src: require('../page-two/guang.png') },
        { src: require('../page-two/btn.png') },
        { src: require('../page-two/guang1.png') },
        { src: require('../page-two/guang2.png') },
        { src: require('../page-two/kv_car.png') },
        { src: require('../page-two/kv_moon.png') },
        { src: require('../page-two/ltr_btn-detailes.png') },
        { src: require('../page-two/ltr_cloud.png') },
        { src: require('../page-two/ltr_details.png') },
        { src: require('../page-two/ltr_pointer.png') },
        { src: require('../page-two/ltr_round-inner.png') },
        { src: require('../page-two/ltr_round.png') },
        { src: require('../page-two/popbottom.png') },
        { src: require('../page-two/poptop.png') },
        { src: require('../page-two/txt.png') },
      ]
    }
  },
  components: {
    Logo
  },
  methods: {
    generateId (index) {
      return 'mImg' + index
    },
    go () {
      this.$props.isShow.isLDShow = false
      this.$props.isShow.isKVShow = true
      //this.$props.isShow.isPTShow = true
    },
    loadNextImg(imgID, max){
      let allImg = $('.preImgBox img')
      let _this = this
      let imgSrc = this.preLoadImg[imgID]['src']

      allImg.eq(imgID).attr('src', imgSrc)
      allImg.eq(imgID).on('load',function () {
          _this.loadingNum = parseInt(imgID / max*100)
            imgID++
            if(imgID >= max){
              console.log('complete')
              _this.loadingNum = 100
                _this.go()
            }else{
              _this.loadNextImg(imgID,max)
            }
        })
    }
  },
  mounted () {
    let that = this
    let allImg = $('.preImgBox img')
    let allImgNum = allImg.length
    let imgID = 0
    setTimeout(() => {
      that.loadNextImg(imgID, allImgNum)
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
.loading {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(#0e132c,  #0e173b 50%, #2a3d61);
  .l-main {
    position: relative;
    padding-top: 11.3125rem /* 181/16 */;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #c3bba1;
    img {
      width: 6.5625rem /* 105/16 */;
      margin-bottom: .625rem /* 10/16 */;
    }
    .l-mask {
      position: absolute;
      width: 6.875rem /* 110/16 */;
      height: 6.875rem /* 110/16 */;
      border-radius: 50%;
      filter: blur(5px);
      box-shadow: 0 0 10px #0e1638;
      background: #0e1638;
      transform: translate(0, 0 /* 50/16 */);
      transform-origin: center;
    }
  }
}

.movingMoon {
  animation: movingMoon 2s linear infinite;
  animation-fill-mode: both;
}

@keyframes movingMoon {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(6.875rem /* 110/16 */, -6.875rem /* 110/16 */);
  }
}
</style>
